import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TenantService } from './components/tenant/tenant.service';

@Component({
    standalone: true,
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [
        RouterOutlet,
    ]
})
export class AppComponent implements OnInit {

    title = 'Hook to Cook';

    private tenantService = inject(TenantService);
    private router = inject(Router);
    private translate = inject(TranslateService);


    constructor() {
        // listens to any routing  (changing of pages) and logs that as a pageview in google analytics
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                (<any>window).ga('set', 'page', event.urlAfterRedirects);
                (<any>window).ga('send', 'pageview');
            }
        });
    }


    ngOnInit() {
        this.translate.setFallbackLang(this.tenantService.config.languageDefault);
        this.translate.use(this.tenantService.config.languageDefault);
    }
}

